import { Link } from "react-router";

import { Panel } from "../components/ui/Panel";

/**
 * Unknown pages, and owner-only pages opened by a tech. The two look the same on
 * purpose: a tech learns nothing about what owners can see.
 */
export function NotFoundPage() {
  return (
    <Panel>
      <h1 className="text-xl font-semibold tracking-tight">Page not found</h1>
      <p className="mt-1 text-muted">
        <Link to="/" className="font-medium text-brand-ink underline">
          Back to today
        </Link>
      </p>
    </Panel>
  );
}
